export const projConstants = {
    PROJ_GETAll: 'project/getall',
    PROJ_OPEN: 'project/open',
    PROJ_CLEAR: 'project/clear',
    PROJ_RETURN: 'project/return',
    PROJ_RESETISSUEFLAG: 'project/resetIssueFlag',
    PROJ_SET_RESOURCE_TOKEN: 'project/setResourceToken'
};